import { createDOMMotionComponentProxy as o } from "./atoms-v2877.js";
import { createMotionComponent as t } from "./atoms-v2878.js";
const e = /* @__PURE__ */ o(t);
export {
  e as motion
};
